import { useRef, useState } from "react"
import { Button, Select, Tooltip, message } from "antd"
import { Paperclip } from "lucide-react"
import { SelfCheckSvg, TipSvg, JumpSvg } from "@/components/svgs/project"

export const TaskItem = ({ task, onStatusChange, onAttachments }: {
  task: API.PROJECTHQ_NEW.Task
  onStatusChange: (task: API.PROJECTHQ_NEW.Task, status: 0 | 1) => Promise<void>
  onAttachments: (task: API.PROJECTHQ_NEW.Task) => void
}) => {
  const [busy, setBusy] = useState(false)
  const writing = useRef(false)
  const write = async (action: () => Promise<void>) => {
    if (writing.current) return
    writing.current = true; setBusy(true)
    try { await action() } catch (error) { message.error(typeof error === "string" ? error : "任务更新失败") }
    finally { writing.current = false; setBusy(false) }
  }
  const tip = task.type === "tip"
  return <div className="flex items-center gap-3 p-4 mb-3 bg-white border rounded-lg">
    {tip ? <Tooltip title="提示关注"><span className="p-1 rounded-full text-yellow-700 bg-yellow-100"><TipSvg /></span></Tooltip>
      : task.type === "selfcheck" ? <span className="p-1 rounded-full text-purple-500 bg-purple-100"><SelfCheckSvg /></span>
      : task.type === "jump" ? <span className="p-1 rounded-full text-orange-500 bg-orange-100"><JumpSvg /></span>
      : <span className="text-xs p-1 rounded bg-gray-100">DDS</span>}
    <div className={`flex-1 ${tip ? "text-gray-500" : ""}`}>{task.value}</div>
    <div className="w-[100px] shrink-0">
      {!tip && <Select aria-label={`${task.value}状态`} className="w-full" value={task.status} disabled={busy} loading={busy}
        onChange={(status: 0 | 1) => void write(() => onStatusChange(task, status))}
        options={[{ value: 0, label: "未完成" }, { value: 1, label: <span className="text-green-500">已完成</span> }]} />}
    </div>
    <div className="w-[120px] shrink-0 flex flex-wrap justify-center gap-2">
      {task.type === "jump" && task.url && <a href={task.url} target="_blank" rel="noopener noreferrer" className="text-blue-500 flex items-center gap-1"><JumpSvg />跳转</a>}
      {task.type === "dds" && (task.isNotDdsSpecial && task.url
        ? <a href={task.url} target="_blank" rel="noopener noreferrer" className="text-blue-500 flex items-center gap-1"><Paperclip size={14} />文档管理</a>
        : <span className="text-xs text-gray-400">请到PM打开DDS空间</span>)}
      {(task.type === "dds" || task.type === "selfcheck") && task.isUploadAttachment && <Button size="small" onClick={() => onAttachments(task)}>附件管理</Button>}
    </div>
  </div>
}
